module.exports = __webpack_public_path__ + "img/3_smoke.fe1e0ca4.png";